import { useHasGlucoseData } from "./useHasGlucoseData"
import { useLastOutsideOfNormalReadingTime } from "./useLastOutsideOfNormalReadingTime"
import { useNextGlucoseReading } from "./useNextGlucoseReading"

export type ReturnValue = string | null | undefined

/*
 * this hook returns:
 * - the first timestamp the readings before now that are continuously in range
 * - null if the user is not currently in range
 * - undefined if the user has no glucose readings
 * - undefined if loading
 */
export function useTimeInRangeCalculation(): ReturnValue {
  const hasGlucoseData = useHasGlucoseData()
  const lastOutsideOfNormalReadingTime = useLastOutsideOfNormalReadingTime()
  const nextGlucoseReadingTime = useNextGlucoseReading(
    hasGlucoseData,
    lastOutsideOfNormalReadingTime,
  )
  return nextGlucoseReadingTime
}
